import {
  CREATE,
  DELETE,
  GET_LIST,
  GET_ONE,
  UPDATE,
} from 'react-admin'
import {convertImagePath} from './ImageHandler'

export function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/prices'
  let options = {}

  switch (type) {
    case CREATE:
      options.method = 'POST'
      options.data = params.data
      break
    case GET_LIST:
      const {page, perPage} = params.pagination
      const {field, order} = params.sort
      options.params = {
        ...params.filter,
        sort: field,
        order: order,
        start: (page - 1) * perPage,
        perPage: perPage,
      }
      break
    case GET_ONE:
      url += `/${params.id}`
      break
    case UPDATE:
      url += `/${params.id}`
      options.method = 'PUT'
      const {memo, price} = params.data
      options.data = {memo, price}
      break
    case DELETE:
      url += `/${params.id}`
      options.method = 'DELETE'
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res
  switch (type) {
    case GET_LIST:
      data.data.forEach(row => row.titleImage = convertImagePath(row.titleImage, 'small'))
      ret = data
      break
    case GET_ONE:
      data.titleImage = convertImagePath(data.titleImage, 'large')
      ret = {data}
      break
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
